import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import {
  transactionFields,
  transactionReceiverFields,
} from '../../constants/transaction';

const TransactionReceiverInformation = ({ info, t }) => {
  const participantData = info[transactionFields.RECEIVER_INFORMATION];
  const transactionType = info.transactionType;

  if (!participantData) return null;

  function isExportTransaction() {
    return transactionType === 'EXPORT';
  }

  function isImportTransaction() {
    return transactionType === 'IMPORT';
  }

  return (
    <Row className="global-margin-bottom-10">
      {isExportTransaction() ? (
        <>
          <Col span={8}>
            <b>{t('receiver.exportCountry')}:</b>{' '}
            {participantData?.[transactionReceiverFields.COUNTRY]}
          </Col>
          <Col span={8}>
            <b>{t('receiver.exportReceiver')}:</b>{' '}
            {participantData?.[transactionReceiverFields.RECEIVER]}
          </Col>
        </>
      ) : isImportTransaction() ? (
        <>
          <Col span={8}>
            <b>{t('receiver.name')}:</b>{' '}
            {participantData?.[transactionReceiverFields.NAME]}
          </Col>
          <Col span={8}>
            <b>{t('receiver.code')}:</b>{' '}
            {participantData?.[transactionReceiverFields.CODE]}
          </Col>
          <Col span={8}>
            <b>{t('receiver.eecsCode')}: </b>
            {participantData?.[transactionReceiverFields.EECS_CODE]}
          </Col>
        </>
      ) : (
        <>
          <Col span={8}>
            <b>{t('receiver.name')}:</b>{' '}
            {participantData?.[transactionReceiverFields.NAME]}
          </Col>
          <Col span={8}>
            <b>{t('receiver.code')}:</b>{' '}
            {participantData?.[transactionReceiverFields.CODE]}
          </Col>
        </>
      )}
    </Row>
  );
};

TransactionReceiverInformation.propTypes = {
  info: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default TransactionReceiverInformation;
